import React, { useState, useEffect } from "react";
import "react-date-range-patched/styles.scss";
import "react-date-range-patched/theme/default.scss";
import { DateRangePicker, createStaticRanges } from 'react-date-range-patched';
import { useTranslation } from "react-i18next";
import moment from "moment";
import { initialRanges } from "./initialRanges.js"
import { endOfDay } from "date-fns"

export default function BaseDateRange ({ onChangeCallback, start_date, end_date, limitDates, minDate, maxDate, singleDate, ...rest }) {
    const { t } = useTranslation('translation', { keyPrefix: 'components.dateDropdown' });
    const ranges = initialRanges(t, minDate, maxDate);
    const staticRanges = createStaticRanges(limitDates ? ranges.filter(r => limitDates.includes(r.id)) : ranges);

    const [state, setState] = useState([{
        startDate: moment().toDate(),
        endDate: moment().toDate(),
        key: "selection"
    }]);
    
    useEffect(() => {
        if (start_date && end_date) {
            setState((prevState) => {
                if (
                    prevState[0].startDate.getTime() !== moment(start_date).toDate().getTime() ||
                    prevState[0].endDate.getTime() !== moment(end_date).toDate().getTime()
                ) {
                    return [{
                        startDate: moment(start_date).toDate(),
                        endDate: moment(end_date).toDate(),
                        key: "selection"
                    }];
                }
                return prevState;
            });
        }
    }, [start_date, end_date]);

    const handleChange = (item) => {
        const selectedRange = item.selection;
        setState([{
            startDate: selectedRange.startDate,
            endDate: selectedRange.endDate,
            key: "selection"
        }]);
        onChangeCallback(selectedRange.startDate, selectedRange.endDate);
    };


    return (
        <DateRangePicker
            onChange={handleChange}
            showSelectionPreview={false}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            direction="vertical"
            inputRanges={[]}
            staticRanges={staticRanges}
            {...(singleDate && { focusedRange:[0, 0] })}
            {...(minDate && { minDate })}
            {...(maxDate ? { maxDate } : {maxDate: endOfDay(new Date())} )}
            {...rest}
        />
    )
}
